var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2928 18.7064C11.4803 18.8939 11.7346 18.9992 11.9998 18.9992C12.265 18.9992 12.5193 18.8939 12.7068 18.7064L14.9998 16.4134L17.2928 18.7064C17.4814 18.8886 17.734 18.9894 17.9962 18.9871C18.2584 18.9848 18.5092 18.8797 18.6946 18.6942C18.88 18.5088 18.9852 18.258 18.9875 17.9958C18.9897 17.7336 18.8889 17.481 18.7068 17.2924L16.4138 14.9994L18.7068 12.7064C18.8889 12.5178 18.9897 12.2652 18.9875 12.003C18.9852 11.7408 18.88 11.49 18.6946 11.3046C18.5092 11.1192 18.2584 11.014 17.9962 11.0118C17.734 11.0095 17.4814 11.1103 17.2928 11.2924L14.9998 13.5854L12.7068 11.2924C12.5182 11.1103 12.2656 11.0095 12.0034 11.0118C11.7412 11.014 11.4904 11.1192 11.305 11.3046C11.1196 11.49 11.0144 11.7408 11.0121 12.003C11.0098 12.2652 11.1106 12.5178 11.2928 12.7064L13.5858 14.9994L11.2928 17.2924C11.1053 17.48 11 17.7343 11 17.9994C11 18.2646 11.1053 18.5189 11.2928 18.7064V18.7064Z",
    fill: "#99A4A3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#EFF5F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/closeModal.0eb91b544d7ae7ce16b0494a898fb3b2.svg";
export { ForwardRef as ReactComponent };